"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theme
const StyledTitle = _styledComponents.default.h1.withConfig({
  displayName: "PageDetailsTitle__StyledTitle",
  componentId: "design-system__sc-1yhiuu1-0"
})(["font-family:", ";font-size:1.5rem;font-weight:", ";line-height:", ";color:", ";align-self:center;margin:0;"], _BaseTheme.default.type.family.system, _BaseTheme.default.type.weight.bold, _BaseTheme.default.type.lineHeight.large, _BaseTheme.default.colors.black);

const PageDetailsTitle = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(StyledTitle, null, children);
};

PageDetailsTitle.propTypes = {
  children: _propTypes.default.string.isRequired
};
var _default = PageDetailsTitle;
exports.default = _default;